module.exports = "/assets/landing-rc/promo/cola-photo.png?WMhAXS7";